<div
  fxLayout
  fxLayoutAlign="end center"
  style="padding: 0 16px"
  fxLayoutGap="32px"
>
  <div fxLayout fxLayoutAlign="center center" fxLayoutGap="6px">
    <mat-label>Items per page:</mat-label>
    <mat-form-field>
      <mat-select [value]="pageSize" (valueChange)="handlePageSizeChange($event)">
        <mat-option
          *ngFor="let pageOption of pageSizeOptions"
          [value]="pageOption"
          >{{ pageOption }}</mat-option
        >
      </mat-select>
    </mat-form-field>
  </div>

  <mat-label> {{ start }} - {{ end }} of {{ length }}</mat-label>

  <pagination-controls
    [responsive]="true"
    (pageChange)="handlePageChange($event)"
    [id]="id"
  ></pagination-controls>
</div>
